function _extends() {
    _extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source){
                if (Object.prototype.hasOwnProperty.call(source, key)) {
                    target[key] = source[key];
                }
            }
        }
        return target;
    };
    return _extends.apply(this, arguments);
}
import * as React from "react";
import styled from "styled-components";
import ToolTipContent from "./components/ToolTipContent.js";
import AnimContainer from "./styles/AnimContainer.js";
import Wrapper from "./styles/Wrapper.js";
import StickyPortal from "../StickyPortal";
let tooltipIdCounter = 0;
const animaterStyle = {
    pointerEvents: 'none',
    width: '100%'
};
class ToolTip extends React.Component {
    static uniqueID(prefix) {
        const id = `${++tooltipIdCounter}`;
        return prefix ? prefix + id : id;
    }
    componentDidUpdate(prevProps, prevState) {
        const { active } = this.state;
        if (prevState.active !== active) {
            this.setState({
                launchAnim: active
            });
        }
    }
    static getDerivedStateFromProps(nextProps, prevState) {
        if (nextProps.isActive !== prevState.propsIsActive) {
            return {
                active: nextProps.isActive,
                propsIsActive: nextProps.isActive
            };
        }
        if (!nextProps.message) {
            return {
                active: false
            };
        }
        return null;
    }
    addDescribedBy(tooltipID) {
        return React.Children.map(this.props.children, (e)=>/*#__PURE__*/ React.cloneElement(e, {
                'aria-describedby': tooltipID
            }));
    }
    render() {
        const { _ref, className, 'data-testid': dataTestId, direction, innerStyle, isOpened, locator, message, noWrap, refreshEventOff, refreshEventOn, style, zIndex } = this.props;
        const { active, id: tooltipID, launchAnim } = this.state;
        const opened = isOpened || active;
        const realLaunchAnim = isOpened || launchAnim;
        return /*#__PURE__*/ React.createElement(Wrapper, {
            className: className,
            "data-testid": dataTestId,
            id: tooltipID,
            onClick: this.onClickId,
            onMouseOver: this.handleMouseOver,
            onPointerLeave: this.handleMouseLeave,
            role: "tooltip",
            style: _extends({}, style, {
                position: 'relative'
            })
        }, !!message && /*#__PURE__*/ React.createElement(StickyPortal, {
            isOpened: opened,
            position: direction ? direction.split(/(?=[A-Z])/)[0] : 'top',
            refreshEventOff: refreshEventOff,
            refreshEventOn: refreshEventOn,
            zIndex: zIndex
        }, /*#__PURE__*/ React.createElement(AnimContainer, {
            direction: this.getDirection(),
            isActive: realLaunchAnim,
            style: animaterStyle
        }, /*#__PURE__*/ React.createElement(ToolTipContent, {
            active: opened,
            "data-testid": dataTestId ? `${dataTestId}-message` : '',
            direction: direction,
            locator: locator,
            message: message,
            noWrap: noWrap,
            ref: _ref,
            style: innerStyle
        }))), this.addDescribedBy(tooltipID));
    }
    constructor(...args){
        super(...args);
        this._activateTimeout = null;
        this.state = {
            active: this.props.isActive || false,
            propsIsActive: this.props.isActive || false,
            id: this.props.id || ToolTip.uniqueID('tooltip-'),
            launchAnim: false
        };
        this.handleMouseOver = ()=>{
            const { delay, isActive, message } = this.props;
            if (!!message && !isActive && !this._activateTimeout) {
                this._activateTimeout = setTimeout(()=>{
                    this._activateTimeout = null;
                    this.setState({
                        active: true
                    });
                }, delay);
            }
        };
        this.handleMouseLeave = ()=>{
            const { isActive } = this.props;
            if (!isActive) {
                if (!!this._activateTimeout) {
                    clearTimeout(this._activateTimeout);
                    this._activateTimeout = null;
                }
                this.setState({
                    active: false
                });
            }
        };
        this.onClickId = ()=>{
            const { id } = this.state;
            const { onClick } = this.props;
            onClick && onClick(id);
        };
        this.getDirection = ()=>{
            const { direction } = this.props;
            if (this.isVerticalDirection()) {
                return this.isBottomDirection() ? '-y2' : 'y2';
            }
            if (this.isHorizontalDirection()) {
                return direction === 'right' ? '-x2' : 'x2';
            }
            return undefined;
        };
        this.isBottomDirection = ()=>{
            const { direction } = this.props;
            return direction === 'bottom' || direction === 'bottomLeft' || direction === 'bottomRight';
        };
        this.isHorizontalDirection = ()=>{
            const { direction } = this.props;
            return direction === 'right' || direction === 'left';
        };
        this.isTopDirection = ()=>{
            const { direction } = this.props;
            return direction === 'top' || direction === 'topLeft' || direction === 'topRight';
        };
        this.isVerticalDirection = ()=>this.isTopDirection() || this.isBottomDirection();
    }
}
ToolTip.defaultProps = {
    delay: 0,
    direction: 'top'
};
export { ToolTip as DocToolTip };
export default styled(/*#__PURE__*/ React.forwardRef((props, ref)=>/*#__PURE__*/ React.createElement(ToolTip, _extends({
        _ref: ref
    }, props))))``;
